import http from "@/axios/http-common";
import ErrorAlert from "@/utility/ErrorAlert";
import { KonteksAptol, KonteksBatasJkn } from "@/utils/resepTerstruktur";

export interface KonfigResepTerstruktur {
  unit_id: string;
  aktif: boolean;
  wajib: boolean;
}

export interface ResepTerstrukturUnitRow {
  id: number;
  unit_id: string;
  unit_nama: string | null;
  aktif: boolean;
  wajib: boolean;
  keterangan: string | null;
  diubah_oleh: string | null;
  updated_at: string | null;
}

const BASE_SA = "/superadmin/resep-terstruktur-unit";

function tanganiGalat<T>(p: Promise<T>): Promise<T> {
  return p.catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
}

async function konfigUnit(unitId: string): Promise<KonfigResepTerstruktur> {
  const kosong = { unit_id: unitId, aktif: false, wajib: false };

  if (!unitId) {
    return kosong;
  }

  const res = await http
    .getData(`/resep-terstruktur/unit/${encodeURIComponent(unitId)}`)
    .catch(() => null);

  return res && res.data && res.data.data ? res.data.data : kosong;
}

async function batasJkn(
  registerId: string | number,
  unitId: string,
  kecualiResep: number | null
): Promise<KonteksBatasJkn | null> {
  if (!registerId || !unitId) {
    return null;
  }

  const params: Record<string, string | number> = {
    register_id: registerId,
    unit_id: unitId
  };
  if (kecualiResep) {
    params.kecuali_resep = kecualiResep;
  }

  const res = await http
    .getDataParam("/resep-terstruktur/batas-jkn", { params })
    .catch(() => null);

  return res && res.data && res.data.data ? res.data.data : null;
}

async function aptol(
  registerId: string | number,
  obatId: string | null = null
): Promise<KonteksAptol | null> {
  if (!registerId) {
    return null;
  }

  const params: Record<string, string | number> = { register_id: registerId };
  if (obatId) {
    params.obat_id = obatId;
  }

  const res = await http
    .getDataParam("/resep-terstruktur/aptol", { params })
    .catch(() => null);

  return res && res.data && res.data.data ? res.data.data : null;
}

async function daftarUnit(): Promise<ResepTerstrukturUnitRow[]> {
  const res = await tanganiGalat(http.getData(BASE_SA));
  return res.data.data || [];
}

async function tambahUnit(
  payload: Partial<ResepTerstrukturUnitRow>
): Promise<ResepTerstrukturUnitRow> {
  const res = await tanganiGalat(http.postData(BASE_SA, payload));
  return res.data;
}

async function ubahUnit(
  id: number,
  payload: Partial<ResepTerstrukturUnitRow>
): Promise<ResepTerstrukturUnitRow> {
  const res = await tanganiGalat(http.putData(`${BASE_SA}/${id}`, payload));
  return res.data;
}

async function hapusUnit(id: number): Promise<void> {
  await tanganiGalat(http.deleteData(`${BASE_SA}/${id}`));
}

export default {
  konfigUnit,
  batasJkn,
  aptol,
  daftarUnit,
  tambahUnit,
  ubahUnit,
  hapusUnit
};
